import React, { useState, useEffect } from "react";
import { getData } from "../../../../functions/request";
import {
  formatDateHourToBR,
  saveData,
} from "../../../../functions/functionsUtility";
import { DescriptionMinMax } from "../../../../layout";
import { dateMask } from "../../../../functions/utils";
import { cafeOptions } from "../../../../constants/constants";
const dayjs = require("dayjs");

export default function IntergraosCafeLondres() {
  const [cotacoesData, setCotacoesData] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    getData("cafe_lond", "getLastCafLond", "insertCafLond")
      .then((data) => {
        setCotacoesData(data);
      })
      .finally(() => {
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        setHasError(err?.message ?? "Ocorreu um erro.");
        console.log(err);
      });
  }, []);

  const [date, setDate] = useState({
    month: "",
    year: dayjs().year().toString(),
  });
  const onChange = (value, type) => {
    if (type === "month") {
      setDate((prevState) => ({ ...prevState, month: value }));
    } else if (type === "year") {
      setDate((prevState) => ({ ...prevState, year: value }));
    }
  };

  useEffect(() => {
    setCotacoesData((prevState) => ({
      ...prevState,
      caf_periodo: dayjs(`01/${date.month}/${date.year}`, "DD/MM/YYYY").format(
        "YYYY-MM-DDTHH:mm:ss.SSS[Z]"
      ),
    }));
  }, [date]);

  return (
    <>
      <DescriptionMinMax
        title={"Intergrãos - Café - Londres - Alterando Mercado Futuro"}
        data={cafeOptions}
        date={formatDateHourToBR(cotacoesData.caf_data)}
        datePickerOnChange={onChange}
        datePickerValue={date.year}
        setState={setCotacoesData}
        state={cotacoesData}
        stateKey={"caf_valor"}
        onClickButton={() => saveData(cotacoesData)}
        isLoading={isLoading}
        hasError={hasError}
      />
    </>
  );
}
